<template>
  <div class="log">
    <div class="event">{{ data.type }}</div>
    <div class="time">{{ data.time + ' ms' }}</div>
    <div class="date">{{ getDate }}</div>
    <div class="email">
      <span v-if="data.metadata.email" class="email-active" @click="searchByUser">{{ data.metadata.email }}</span>
      <span v-else> not logged in</span>
    </div>
    <div class="dialogId">
      <span class="link" title="Open Dialog" v-if="data.metadata.dialogId" @click="openDialog(data.metadata.dialogId)">{{ dialogTitle }}</span>
    </div>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'LogRow',
  props: {
    data: Object
  },
  data() {
    return {
      dialogTitle: null
    }
  },
  methods: {
    openDialog(id) {
      const link = `${window.location.origin}/play?exercise_id=${id}`;
      window.open(link);
    },
    loadTitle() {
      axios({
        method: 'post',
        url: `${process.env.VUE_APP_SERVER_URL}loadDialogTitle`,
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem('token') 
        },
        data: {
          dialogId: this.data.metadata.dialogId
        }
      }).then(data => {
        this.dialogTitle = data.data.data.title;
      }).catch(err => {
        console.log(err);
      })
    },
    searchByUser() {
      this.$emit('searchByUser', this.data.metadata.email);
    }
  },
  computed: {
    getDate() {
      const date = new Date(this.data.date);
      let day = date.getDate();
      if(day < 10) {
        day = '0' + day;
      }
      let month = date.getMonth() + 1;
      if(month < 10) {
        month = '0' + month;
      }
      let year = date.getFullYear();

      let hour = date.getHours();
      if(hour < 10) {
        hour = '0' + hour;
      }
      let minutes = date.getMinutes();
      if(minutes < 10) {
        minutes = '0' + minutes;
      }

      let formated = `${day}/${month}/${year} - ${hour}:${minutes}`;
      return formated;
    },
    getDateShort() {
      const date = new Date(this.data.date);
      let day = date.getDate();
      if(day < 10) {
        day = '0' + day;
      }
      let month = date.getMonth() + 1;
      if(month < 10) {
        month = '0' + month;
      }
      let year = date.getFullYear();

      let formated = `${day}/${month}/${year}`;
      return formated;
    },
    getMeta() {
      if(this.data.metadata) {
        return this.data.metadata[Object.keys(this.data.metadata)[0]];
      } else {
        return ''
      }
    }
  },
  mounted() {
    if(this.data.metadata.dialogId) {
      this.loadTitle();
    }
  }
}
</script>

<style lang="scss" scoped>
.log {
  width: 90%;
  height: 3.5rem;
  background-color: rgb(238, 238, 238);
  margin-bottom: 1rem;
  border-radius: 0.2rem;
  display: flex;

  @media (max-width: 1050px) {
    width: 95%;
  }
  @media (max-width: 850px) {
    width: 90%;
    height: 17.5rem;
    flex-direction: column;
  }

  .event {
    width: 20%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: bold;

    @media (max-width: 1050px) {
      width: 10%;
    }
    @media (max-width: 850px) {
      width: 100%;
      justify-content: flex-start;
      padding-left: 2rem;
    }
    @media (max-width: 400px) {
      padding-left: 1.5rem;
    }
  }

  .time {
    width: 10%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    font-style: italic;
    @media (max-width: 850px) {
      width: 100%;
      justify-content: flex-start;
      padding-left: 2rem;
    }
    @media (max-width: 400px) {
      padding-left: 1.5rem;
    }
  }

  .date {
    width: 20%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    @media (max-width: 850px) {
      width: 100%;
      justify-content: flex-start;
      padding-left: 2rem;
    }
    @media (max-width: 400px) {
      padding-left: 1.5rem;
    }
  }

  .email {
    width: 25%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;

    @media (max-width: 1050px) {
      width: 30%;
    }
    @media (max-width: 850px) {
      width: 100%;
      justify-content: flex-start;
      padding-left: 2rem;
    }
    @media (max-width: 400px) {
      padding-left: 1.5rem;
    }

    .email-active {
      transition: 0.2s;
      &:hover {
        color: #11b6a6;
        cursor: pointer;
      }
    }
  }

  .dialogId {
    width: 25%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    
    .link {
      transition: 0.2s;
      &:hover {
        color: #11b6a6;
        cursor: pointer;
      }
    }

    @media (max-width: 1050px) {
      width: 30%;
    }
    @media (max-width: 850px) {
      width: 100%;
      justify-content: flex-start;
      padding-left: 2rem;
    }
    @media (max-width: 400px) {
      padding-left: 1.5rem;
    }
  }
}
</style>